module.exports = __webpack_public_path__ + "img/fundo3.1ae2932d.png";